__webpack_require__.p = "https://hansyulian.github.io/automobile-poc-demo/";